module.exports = __webpack_public_path__ + "img/card-f-bright.5aa3d78c.png";